<h2 mat-dialog-title>
  {{ pricingDetailsDialogData.productName }} Pricing Details
</h2>
<div class="header-text">
  Select your state below to receive a detailed cost breakdown
  <span *ngIf="pricingDetailsDialogData.productName as productName">
    for {{ productName }}
  </span>
  .
</div>
<div class="state-selector">
  <form [formGroup]="pricingDetailsForm">
    <mat-form-field>
      <input
        matInput
        formControlName="state"
        type="text"
        name="state"
        placeholder="State"
        required
        [matAutocomplete]="state"
        (input)="updateSearchTerm($event.target.value)"
      />
      <mat-autocomplete #state="matAutocomplete" [displayWith]="nameDisplayFn">
        <mat-optgroup
          *ngFor="let group of stateGroupOptions$ | async"
          [label]="group.letter"
        >
          <mat-option *ngFor="let state of group.states" [value]="state">
            {{ state.name }}
          </mat-option>
        </mat-optgroup>
      </mat-autocomplete>
    </mat-form-field>
    <app-pricing-details-breakdown
      [productName]="pricingDetailsDialogData.productName"
      [input]="selectedState$ | async"
      [pricingInfo]="pricingDetailsDialogData.pricing"
    ></app-pricing-details-breakdown>
  </form>
</div>
<mat-dialog-actions>
  <button mat-button color="primary" (click)="close()">Close</button>
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    *ngIf="pricingDetailsDialogData.showEnableButton"
  >
    Enable
    <ng-container *ngIf="pricingDetailsDialogData.productName as productName">
      {{ productName }}
    </ng-container>
  </button>
</mat-dialog-actions>
